<template>
  <div class="reportList-table">
    <div class="c-flex c-h-1">
      <div
        style="
          width: 30%;
          height: 100%;
          padding-right: 10px;
          box-sizing: border-box;
          overflow-y: inherit;
          margin-right: 60px;
        "
        v-if="isShowFilter"
      >
        <slot name="filterLeft"></slot>
        <c-filter :colName="reportData.config" :filterThat="this" :isSave="false"></c-filter>
      </div>
      <div
        :style="
          isShowFilter ? 'width: 68%;height: calc(100% - 50px);' : 'width: 100%;height: 100%;'
        "
      >
        <slot name="filterRight"></slot>
        <el-table :data="fpi.data" style="width: 100%" height="100%">
          <template v-for="(item, i) in extFields">
            <template v-if="item.type == 'select' || item.type == 'radio'">
              <el-table-column
                :prop="item.name"
                :label="item.nameDisp"
                :key="i"
                min-width="150px"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ codelabel(item.valueOption, scope.row[item.name]) }}
                </template>
              </el-table-column>
            </template>
            <!-- 省 -->
            <el-table-column
              v-else-if="item.name == 'province'"
              :prop="item.name"
              :label="item.nameDisp"
              :key="i"
              :width="item.width || '120px'"
              :fixed="item.fixed"
              show-overflow-tooltip
              :formatter="osg.formatProvince"
            ></el-table-column>
            <!-- 市 -->
            <el-table-column
              v-else-if="item.name == 'city'"
              :prop="item.name"
              :label="item.nameDisp"
              :key="i"
              :width="item.width || '120px'"
              :fixed="item.fixed"
              show-overflow-tooltip
              :formatter="osg.formatCity"
            ></el-table-column>
            <!-- 区 -->
            <el-table-column
              v-else-if="item.name == 'district'"
              :prop="item.name"
              :label="item.nameDisp"
              :key="i"
              :width="item.width || '120px'"
              :fixed="item.fixed"
              show-overflow-tooltip
              :formatter="osg.formatDistrict"
            ></el-table-column>
            <!-- 数组 -->
            <el-table-column
              v-else-if="item.type == 'data'"
              :prop="item.name"
              :label="item.nameDisp"
              :key="i"
              :width="item.width || '120px'"
              :fixed="item.fixed"
            >
              <template
                slot-scope="scope"
                v-if="scope.row[item.name] && scope.row[item.name].length > 0"
              >
                <el-table :data="scope.row[item.name]">
                  <el-table-column
                    :prop="key"
                    :label="value"
                    show-overflow-tooltip
                    v-for="(value, key, index) in item.frontEndConfig.fields"
                    :key="index"
                  ></el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <template v-else>
              <el-table-column
                :prop="item.name"
                :label="item.nameDisp"
                :key="i"
                min-width="150px"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row[item.name] }}
                </template>
              </el-table-column>
            </template>
          </template>
          <!-- <c-table :fields="extFields"> </c-table> -->
        </el-table>
        <el-pagination
          small
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'reportList',
  data() {
    return {
      fpi: {},
      extFields: [],
      formData: {},
      list: [], //分页列表数据
      config: {}, //配置
      options: {} //字典表
    };
  },
  props: {
    //请求的参数
    params: {
      type: Object,
      default: null
    },
    reportData: {
      type: Object,
      default: null
    },
    isShowFilter: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    window.$that = window.$that || '';
    if (this.reportData && this.$util.isJson(this.reportData.config)) {
      this.config = JSON.parse(this.reportData.config);
    } else if (this.reportData && this.reportData.config) {
      this.config = this.reportData.config;
    } else {
      return;
    }
    // console.log(this.config);
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: this.config.colName,
        _all: '1',
        'is:state|integer#and': 1,
        // 'in:showList|Array#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        this.extFields = res.data.filter(item => item.showList && item.showList.includes('1'));
        for (var item of res.data) {
          //解析字段配置
          if (this.$util.isJson(item.frontEndConfig)) {
            item.frontEndConfig = JSON.parse(item.frontEndConfig);
          } else {
            item.frontEndConfig = {};
          }
          if (item.valueOption)
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          //级联
          if (item.type == 'cascade')
            this.options['cascadeCode_' + item.valueOption] = {
              codeId: item.valueOption
            };
        }
        this.osg.codeoption(() => {
          this.getData();
        }, this);
      },
      { noload: true }
    );
  },
  methods: {
    getData() {
      this.searchDate = this.searchDate || [];
      //   var params = {
      //     page: this.fpi.page || 1,
      //     rows: this.fpi.rows || 567,
      //     startDate: '2010-01-01 00:00:00',
      //     endDate: '2050-01-01 00:00:00',
      //     type: 2
      //     // sortField: 'createTime',
      //     // sortOrder: 'desc'
      //     // page: 1,
      //     // rows: 20
      //   };
      //添加过滤器参数
      let filterParams = {};
      if ($that) $that.getParams(filterParams, this.config.colName);
      //   console.log(this.$parent.date, this.date);
      //   console.log(this.date.dateRange(this.reportData.filterCondition.date));
      let dateRange = this.reportData.filterCondition.date
        ? this.date.dateRange(this.reportData.filterCondition.date)
        : {};
      if (dateRange.endDate && dateRange.endDate.indexOf(' ') == -1) {
        dateRange.endDate = dateRange.endDate + ' 23:59:59';
      }
      //过滤器参数与报表固定要传的参数分开
      var params = Object.assign(
        this.isShowFilter ? filterParams || {} : this.config.params,
        this.isShowFilter ? this.config.fixedParams : this.config.fixedParams,
        dateRange
      );
      console.log(params);
      this.osg.ajax(
        this.config.url,
        params,
        res => {
          if (res.data) {
            this.$nextTick(() => {
              this.fpi = res;
              //所有数据
              this.list = JSON.parse(JSON.stringify(res.data));
              //根据传递的参数进行排序
              if (this.config.sortField && this.config.sortOrder) {
                let sortField = this.config.sortField;
                let sortOrder = this.config.sortOrder;
                //默认最新排最后面，传了desc则反过来
                this.list =
                  sortOrder == 'desc'
                    ? this.list.sort((q, n) => n[sortField] - q[sortField])
                    : this.list.sort((q, n) => q[sortField] - n[sortField]);
              }
              this.fpi.total = this.list.length;
              this.fpi.page = 1;
              this.fpi.rows = 10;
              this.fpi.data = JSON.parse(JSON.stringify(this.list.slice(0, 10)));
              this.$forceUpdate();
              console.log(this.list, this.fpi);
            });
            //   console.log(this.fpi.total);//总页数
          }
          // this.$nextTick(() => {
          //   this.fpi = res;
          //   console.log(this.fpi.data);
          // });
        },
        { noload: true }
      );
    },
    //TODO:前端假分页
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.fpi.page = 1;
      //   debugger;
      //   this.getData();
      this.fpi.data = JSON.parse(
        JSON.stringify(
          this.list.slice(
            this.fpi.page * this.fpi.rows - this.fpi.rows,
            this.fpi.page * this.fpi.rows
          )
        )
      );
      //   console.log(this.fpi.page * this.fpi.rows - this.fpi.rows, this.fpi.page * this.fpi.rows);
      this.$forceUpdate();
    },
    //TODO:前端假分页
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.fpi.data = JSON.parse(
        JSON.stringify(
          this.list.slice(
            this.fpi.page * this.fpi.rows - this.fpi.rows,
            this.fpi.page * this.fpi.rows
          )
        )
      );
      //   console.log(this.fpi.page * this.fpi.rows - this.fpi.rows, this.fpi.page * this.fpi.rows);
      this.$forceUpdate();
      //   this.getData();
    },
    codelabel: function(codeType, codeValue) {
      if (codeType) {
        var opts = this.options[codeType] || this.options[codeType.toLowerCase()]; // 避免有些字典表codeType是大写,预置没有
      }
      if (opts) {
        for (var i = 0; i < opts.length; i++) {
          if (codeValue == opts[i].value) return opts[i].label;
        }
      }
      if (!codeValue) {
        return codeValue;
      } else {
        return '未知';
      }
    }
  }
};
</script>
<style>
.reportList-table {
  width: 100%;
  /* height: 306px; */
  /* height: 70%; */
  height: 88%;
}
</style>
